'use strict';
const angular = require('angular');

export class ConnectedAccountDetailsComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.data = this.config.data;
  };

  ok() {
    this.close();
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.connectedAccountDetails', [])
  .component('connectedAccountDetails', {
    template: require('./connected-account-details.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ConnectedAccountDetailsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/connected-account-details/connected-account-details.component.js